import formComponents from '@/components/iglobalwin/formComponents/index.js';
import single from '@/common/singleFormCreate.js';

export default function (
    { 
        getFormData,
        load,
        submit, 
        submitSucess,
        submitValidateFail, 
        mixins, 
        render
    },
) {
    const formPage = single({
        getFormData,
        load,
        submit,
        submitSucess,
        submitValidateFail,
        mixins: mixins
    });

    formPage.render = render;
    formPage.components = { ...formComponents };
    return formPage;
}
